export const SIGN_DOCUMENT = "v2/signature/sign";
export const REFUSED_DOCUMENT = "v2/signature/refused";